import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createStyles,
  Card,
  Text,
  SimpleGrid,
  UnstyledButton,
  Anchor,
  Group,
  Indicator,
  Modal,
  ActionIcon,
  Title
} from '@mantine/core';
import {
  IconBell,
  IconSettings,
  IconUsers,
  IconFileSettings,
  IconUserPlus,
  IconGavel,
  IconBuildingBank,
  IconRepeat,
  IconReceiptRefund,
  IconReceipt,
  IconReceiptTax,
  IconReport,
  IconCashBanknote,
  IconBook,
  IconCalendar,
  IconMessage,
  IconArrowLeft
} from '@tabler/icons';

import { 
    fieldInfoUpdated,
    selectSectionData,
} from '../features/home/homeSlice';

//needed:create remaining pages
import AuctionItemMgmt from '../pages/AuctionItemMgmt';
import AlertsPage from '../pages/AlertsPage';
import AccntSettingsPage from '../pages/AccntSettingsPage';
import SubscribersPage from '../pages/SubscribersPage';
import SchedulePage from '../pages/SchedulePage';
import ReportsPage from '../pages/ReportsPage';
import BizMgmtPage from '../pages/BizMgmtPage';
import StaffPage from '../pages/StaffPage';
import DocsPage from '../pages/DocsPage';
import MsgsPage from '../pages/MsgsPage';


const avail_parents = [
    { title: 'Alerts', item: 'alerts_5', icon: IconBell, color: 'violet' },//
    { title: 'Account Settings', item: 'accnt_settings_5', icon: IconSettings, color: 'indigo' },//
    { title: 'Subscribers', item: 'subscribers_5', icon: IconUserPlus, color: 'blue' },
    { title: 'Schedule', item: 'schedule_5', icon: IconCalendar, color: 'teal' },
    { title: 'Auctions', item: 'auctions_5', icon: IconGavel, color: 'cyan' },
    //{ title: 'Reports', item: 'reports_5', icon: IconReport, color: 'pink' },
    { title: 'Business Mgmt', item: 'biz_mgmt_5', icon: IconFileSettings, color: 'orange' },
    { title: 'Staff', item: 'staff_5', icon: IconUsers, color: 'green' },
    { title: 'Docs', item: 'docs_5', icon: IconBook, color: 'grey' },
    { title: 'Msgs', item: 'msgs_5', icon: IconMessage, color: 'black' },
];

const useStyles = createStyles((theme) => ({
    card: {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
        margin: '0 auto',
        maxWidth: '800px'
    },
    closeBtn: {
        color: 'black',
        transform: 'scale(1.5)',
    },

  title: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    fontWeight: 700,
  },

  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    borderRadius: theme.radius.md,
    height: '90px',
    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
    transition: 'box-shadow 150ms ease, transform 100ms ease',

    '&:hover': {
      boxShadow: theme.shadows.md,
      transform: 'scale(1.05)',
    },
  },
}));

//redux map, event handling, dispatch

export function DashboardGrid() {
    const { classes, theme } = useStyles();
    const dispatch = useDispatch();
    const component_md = {
        par: 'dashboard',
        child: 'home',
        section: 'home_section_6',
    }

    //will have to be dynamically rendered for title
    const back_button = 
            <ActionIcon color="dark" size="1.9em">
                <IconArrowLeft />
            </ActionIcon>;
    //descript:selector area
    const redux_map = {
        alerts_5: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'alerts_5'
            }
        )),
    };
    console.log('prior to redux map being created');
    
    //descript:local state control
    //needed:add this to redux map
    const [auctionMgmtOpened, setAuctionMgmtOpened] = useState(false);//has page
    const [alertsOpened, setAlertsOpened] = useState(redux_map['alerts_5']);//has page
    const [accntSettingsOpened, setAccntSettingsOpened] = useState(false);//has page
    const [subscribersOpened, setSubscribersOpened] = useState(false);//has page
    const [scheduleOpened, setScheduleOpened] = useState(false);//has page
    //const [reportsOpened, setReportsOpened] = useState(false);//has page
    const [bizMgmtOpened, setBizMgmtOpened] = useState(false);//has page
    const [staffOpened, setStaffOpened] = useState(false);//has page
    const [docsOpened, setDocsOpened] = useState(false);//has page
    const [msgsOpened, setMsgsOpened] = useState(false);//has page
    

    //const onGalleryPreviewOpen = (e) => setGalleryPreviewOpen((o) => !o);
    const handleItemClick = (name, e) => {
        let res = true;
        let value = e;
        
        switch(name){
            case 'alerts_5':
                setAlertsOpened((o) => !o);
                value = alertsOpened;
                console.log(`value of alerts opened:\n\n${alertsOpened}`)
                break;
            case 'accnt_settings_5':
                setAccntSettingsOpened((o) => !o);
                value = accntSettingsOpened;
                console.log(`value of alerts opened:\n\n${alertsOpened}`)
                break;
            case 'subscribers_5':
                setSubscribersOpened((o) => !o);
                value = subscribersOpened;
                console.log(`value of alerts opened:\n\n${alertsOpened}`)
                break;
            case 'schedule_5':
                setScheduleOpened((o) => !o);
                value = scheduleOpened;
                console.log(`value of alerts opened:\n\n${alertsOpened}`)
                break;
            case 'auctions_5':
                setAuctionMgmtOpened((o) => !o);
                value = auctionMgmtOpened;
                console.log(`value of alerts opened:\n\n${alertsOpened}`)
                break;
            /*case 'reports_5':
                setReportsOpened((o) => !o);
                value = reportsOpened;
                console.log(`value of alerts opened:\n\n${alertsOpened}`)
                break;*/
            case 'biz_mgmt_5':
                setBizMgmtOpened((o) => !o);
                value = bizMgmtOpened;
                console.log(`value of alerts opened:\n\n${alertsOpened}`)
                break;
            case 'staff_5':
                setStaffOpened((o) => !o);
                value = staffOpened;
                console.log(`value of alerts opened:\n\n${alertsOpened}`)
                break;
            case 'docs_5':
                setDocsOpened((o) => !o);
                value = docsOpened;
                console.log(`value of alerts opened:\n\n${alertsOpened}`)
                break;
            case 'msgs_5':
                setMsgsOpened((o) => !o);
                value = msgsOpened;
                console.log(`value of alerts opened:\n\n${alertsOpened}`)
                break;
            default:
                console.log(`name error\nissue with ${name}`)
                res = false
        }
        dispatch(fieldInfoUpdated(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: name,
                itemVal: value,
            }
        ))
        return res;
    };


    const handleEvent = (e, name, e_tpe) => {
        //needed:create switch on event_type
        //needed:create nested switch name of event_type
        switch(e_tpe){
            case 'onChange':
                console.log('item changed')
                //handleItemChange(name, e);
                break;
            case 'onClick':
                handleItemClick(name, e.target.value);
                break;
            default:
                console.log(`error occurred with e_tpe\nvalue: ${e_tpe}`);
        }        
    }
  
    
    //add the click here for parent change
    const parent_btns = avail_parents.map((item) => (
        <UnstyledButton key={item.title} className={classes.item} onClick={(e) => handleEvent(e, item.item, "onClick")}>
            {/*<Indicator inline label="10" size={16}>*/}
                <item.icon color={item.color} size="2.25em" />
            {/*</Indicator>*/}
            <Text size="xs" mt={7}>
                {item.title}
            </Text>
        </UnstyledButton>
  ));

    return (
        <>
            <Card withBorder radius="md" className={classes.card}>
                <SimpleGrid cols={3} mt="md">
                    {parent_btns}
                </SimpleGrid>
            </Card>
            {/*
                make the models into a mapped iteration
                * 
                * definitely necessary
                * 
                * */}
            <Modal
                opened={auctionMgmtOpened}
                returnFocus={true}
                closeOnClickOutside={true}
                onClose={() => setAuctionMgmtOpened(false)}
                title={<ActionIcon onClick={() => setAuctionMgmtOpened(false)} color="dark" size="1.9em"><IconArrowLeft /></ActionIcon>}
                overflow="inside"
                fullScreen
            >
                <AuctionItemMgmt/>
            </Modal>
    
            <Modal
                opened={alertsOpened}
                returnFocus={true}
                fullScreen
                closeOnClickOutside={true}
                onClose={() => setAlertsOpened(false)}
                title={<ActionIcon onClick={() => setAlertsOpened(false)} color="dark" size="1.9em"><IconArrowLeft /></ActionIcon>}
                overflow="inside"
            >
                <AlertsPage/>
            </Modal>
            
            <Modal
                opened={accntSettingsOpened}
                returnFocus={true}
                fullScreen
                closeOnClickOutside={true}
                onClose={() => setAccntSettingsOpened(false)}
                title={<ActionIcon onClick={() => setAccntSettingsOpened(false)} color="dark" size="1.9em"><IconArrowLeft /></ActionIcon>}
                overflow="inside"
            >
                <AccntSettingsPage/>
            </Modal>

            <Modal
                opened={subscribersOpened}
                returnFocus={true}
                fullScreen
                closeOnClickOutside={true}
                onClose={() => setSubscribersOpened(false)}
                overflow="inside"
                title={<ActionIcon onClick={() => setSubscribersOpened(false)} color="dark" size="1.9em"><IconArrowLeft /></ActionIcon>}
                size="xl"
                classNames={{
                    close: classes.closeBtn
                }}
            >
                <SubscribersPage/>
            </Modal>

            <Modal
                opened={scheduleOpened}
                returnFocus={true}
                fullScreen
                closeOnClickOutside={true}
                onClose={() => setScheduleOpened(false)}
                title={<ActionIcon onClick={() => setScheduleOpened(false)} color="dark" size="1.9em"><IconArrowLeft /></ActionIcon>}
                overflow="inside"
            >
                <SchedulePage/>
            </Modal>

            {/*<Modal
                opened={reportsOpened}
                returnFocus={true}
                fullScreen
                closeOnClickOutside={true}
                onClose={() => setReportsOpened(false)}
                title={<ActionIcon onClick={() => setReportsOpened(false)} color="dark" size="1.9em"><IconArrowLeft /></ActionIcon>}
                overflow="inside"
            >
                <ReportsPage/>
            </Modal>*/}

            <Modal
                opened={bizMgmtOpened}
                returnFocus={true}
                fullScreen
                closeOnClickOutside={true}
                onClose={() => setBizMgmtOpened(false)}
                title={<ActionIcon onClick={() => setBizMgmtOpened(false)} color="dark" size="1.9em"><IconArrowLeft /></ActionIcon>}
                overflow="inside"
            >
                <BizMgmtPage/>
            </Modal>

            <Modal
                opened={staffOpened}
                returnFocus={true}
                fullScreen
                closeOnClickOutside={true}
                onClose={() => setStaffOpened(false)}
                title={<ActionIcon onClick={() => setStaffOpened(false)} color="dark" size="1.9em"><IconArrowLeft /></ActionIcon>}
                overflow="inside"
            >
                <StaffPage/>
            </Modal>

            <Modal
                opened={docsOpened}
                returnFocus={true}
                fullScreen
                closeOnClickOutside={true}
                onClose={() => setDocsOpened(false)}
                title={<ActionIcon onClick={() => setDocsOpened(false)} color="dark" size="1.9em"><IconArrowLeft /></ActionIcon>}
                overflow="inside"
            >
                <DocsPage/>
            </Modal>

            <Modal
                opened={msgsOpened}
                returnFocus={true}
                fullScreen
                closeOnClickOutside={true}
                onClose={() => setMsgsOpened(false)}
                title={<ActionIcon onClick={() => setMsgsOpened(false)} color="dark" size="1.9em"><IconArrowLeft /></ActionIcon>}
                overflow="inside"
            >
                <MsgsPage/>
            </Modal>
        </>
  );
}
